import { User } from "@jasper/shared";

export const INDENT_STEP = 18;

// The auth context exposes a cookie-derived user that is structurally a subset
// of `User`; the `isUser*` helpers only read `type`/`role`, so this cast is safe.
export const asUser = (user: unknown) => user as User;
